import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisationId String
 * @param blockUI boolean
 * @return {Promise<any>|Promise}
 */
export default (function (organisationId, blockUI) {
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSETS, { organisationId: organisationId });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true, blockUI: blockUI });
    return request.execute();
});
